import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var StatusCheckService = /** @class */ (function () {
    function StatusCheckService(http) {
        this.http = http;
    }
    StatusCheckService.prototype.queryStatusChecking = function (params) {
        this.requestParams = new HttpParams()
            .set('reportDate', params.reportDate)
            .set('licenseNumber', String(params.sellerId));
        return this.http
            .get("license/status/", { headers: { 'Content-Type': 'application/json' }, params: this.requestParams })
            .pipe(map(function (response) {
            return response;
        }));
    };
    StatusCheckService.ngInjectableDef = i0.defineInjectable({ factory: function StatusCheckService_Factory() { return new StatusCheckService(i0.inject(i1.HttpClient)); }, token: StatusCheckService, providedIn: "root" });
    return StatusCheckService;
}());
export { StatusCheckService };
